<template>
    <div class="relative w-screen h-screen bg-slate-900 overflow-hidden flex flex-col items-center justify-center">
        <div class="flex flex-col justify-center items-center">
            <div class="relative z-50 flex items-end text-[10rem] sm:text-[15rem] lg:text-[20rem] theme-text leading-none">
                <p>۴</p>
                <p class="animate-bounce">۰</p>
                <p>۴</p>
            </div>
            <p class="relative z-50 text-xl sm:text-3xl text-slate-200 text-center">صفحه مورد نظر یافت نشد !</p>
            <div class="relative z-50 w-full flex items-center justify-evenly mt-5">
                <button @click="router.go(-1)" class="rounded-full w-20 sm:w-24 lg:w-28 py-2 theme-color text-white sm:text-lg lg:text-xl text-center hover:!bg-transparent border-2 theme-border">بازگشت</button>
                <router-link to="/" class="rounded-full w-20 sm:w-24 lg:w-28 py-2 theme-color text-white sm:text-lg lg:text-xl text-center hover:!bg-transparent border-2 theme-border">خانه</router-link>
            </div>
        </div>

        <!-- bottom shape -->
        <div class="absolute -bottom-12 -right-80 w-full flex items-center gap-8">
            <div v-for="(item, index) in 25" :key="index"
                class="relative min-w-[100px] aspect-square border-4 theme-border rotate-45 opacity-90 rounded-xl blur-[2px]">
                <div class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-80">
                    <div class="relative w-5/6 aspect-square border-4 theme-border rounded-lg"></div>
                    <div class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-70">
                        <div class="relative w-4/6 aspect-square border-4 theme-border rounded-lg"></div>
                        <div class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-60">
                            <div class="relative w-3/6 aspect-square border-4 theme-border rounded-md"></div>
                            <div
                                class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-50">
                                <div class="relative w-2/6 aspect-square border-4 theme-border rounded-md"></div>
                                <div
                                    class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-40">
                                    <div class="relative w-1/6 aspect-square border-4 theme-border"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import router from '@/router';
import { onMounted, ref } from 'vue';

//data
const isMounted = ref(false);


onMounted(() => {
    isMounted.value = true;
})

</script>